import { basicHeaderTheme } from './layoutBasicHeaderTheme';
export const objectHeaderTheme = {
    ...basicHeaderTheme,
    headerLayOut: {
        //position: "fixed",
        //zIndex: "1150",
        //width: "84%"
       // marginLeft:"20%!important"
    }
 } 